import { Component } from "@angular/core"
import { ViewController, NavParams, LoadingController, AlertController, ModalController } from "ionic-angular"

import { UserService } from "../../services/user"
import { EventService } from "../../services/event"
import { UserPickListPage } from "../users/pick-list"
import { EventPickListPage } from "../events/pick-list"

@Component({
  selector: "event-exchange-page",
  templateUrl: "exchange.html",
})
export class EventExchangePage {

  event: any = {}
  comments = ""
  sugEvents = []

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {

    this.event = this.navParams.get("event")
  }

  onExit() {

    this.viewCtrl.dismiss()
  }

  onSetAvailability() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((users) => {

      if (users)
        this.showUserPickListPage(users)
    })

    loading.present()

    UserService.getSectorUsers(this.event.sector._id)
      .then((users) => {

        loading.dismiss(users)
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao obter profissionais",
          buttons: ["Ok"]
        }).present()
      })
  }

  showUserPickListPage(users) {

      const message = "Selecione os profissionais e clique em avançar para visualizar os eventos disponíveis para troca"
      const options = { title: "Selecionar profissionais", message, pickMultiple: true }
      const modal = this.modalCtrl.create(UserPickListPage, { users, options })

      modal.onDidDismiss((users) => {

        if (!users)
          return

        const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

        loading.onDidDismiss((months) => {

          if (months)
            this.showEventPickListPage(users, months)
        })

        loading.present()

        let userIds = []

        users.forEach((user) => userIds.push(user._id))

        EventService.getUsersNextEvents({ event: this.event, userIds })
          .then((months) => {

            loading.dismiss(months)
          })
          .catch((error) => {

            console.log(error)

            loading.dismiss()

            this.alertCtrl.create({
              message: "Falha ao obter eventos",
              buttons: ["Ok"]
            }).present()
          })
      })

      modal.present()
  }

  showEventPickListPage(users, months) {

    if (months.length == 0) {

      let message = "Nenhum evento disponível para"

      if (users.length == 1) {
        message += " o profissional selecionado"
      } else {
        message += " os profissionais selecionados"
      }

      this.alertCtrl.create({
        message,
        buttons: ["Ok"]
      }).present()

      return
    }

    months.forEach((month) => {

      let events = []

      month.events.forEach((event) => {

        event.user = this.getUserById(users, event.userId)
        event.isLoadingPicture = true
        event.selected = false

        events.push(event)
      })

      month.events = events.slice()
    })

    const message = "Selecione os eventos de acordo com a sua disponibilidade para troca"
    const options = { title: "Selecionar eventos", message, pickMultiple: true }
    const modal = this.modalCtrl.create(EventPickListPage, { months, options })

    modal.onDidDismiss((events) => {

      if (!events)
        return

      events.forEach((event) => event.isLoadingPicture = true)

      this.sugEvents = events
    })

    modal.present()
  }

  getUserById(users, id) {

    let user = null

    users.forEach((el) => {

      if (el._id == id)
        user = el
    })

    return user
  }

  availabilityLabel() {

    return this.sugEvents.length == 1 ? "Disponível para o seguinte evento" : "Disponível para os seguintes eventos"
  }

  onConfirm() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((data) => {

      if (data)
        this.viewCtrl.dismiss(data)
    })

    loading.present()

    EventService.exchangeEvent(this.event, this.comments, this.sugEvents)
      .then((event) => {

        loading.dismiss({ exchangeRequested: true, event })
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao solicitar troca do evento",
          buttons: ["Ok"]
        }).present()
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/exchange.ts